import axios from "axios";
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import swal from 'sweetalert';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import UseFullPageLoader from "../../FullPageLoader/UseFullPageLoader";


const EditPage = (props) => {
    document.title = "DirtMap - Edit Page";
    const history = useHistory();
    const [loading, setLoading] = useState(true);
    const [pageInput, setPageInput]= useState([]);
    const [error, setError] = useState([]);
    const [loader, showLoader, hideLoader] = UseFullPageLoader();


    const handleInput = (e) => {
        e.persist();
        console.log(pageInput);

        setPageInput({ ...pageInput, [e.target.name]: e.target.value });
    }

    const handleEditorOnChange = (e, editor) => {
        const data = editor.getData();
        console.log(pageInput);
        console.log( { e, editor, data } );
        setPageInput({ ...pageInput, description:data });
    }

    useEffect(() => {
        const pageId = props.match.params.id;

        axios.get(`api/detail/cms/page/${pageId}`).then(res => {
            console.log(res.data.result);
            if (res.data.result) {
                setPageInput(res.data.result);
            } else if (res.data.success === false) {
                swal("warning", res.data.message, "error");
                history.push('/page/cms/list');
            }
            setLoading(false);
        });

    }, [props.match.params.id, history]);

    if (loading) {
        return <div className="fp-container"><img src={"/images/spinner.gif"} className="fp-loader" alt="loading" /></div>;
    } 

    const updatePage = (e) => {
        e.preventDefault();
        const pageId = props.match.params.id;

        const data = pageInput;

        showLoader();
        axios.get('/sanctum/csrf-cookie').then(response => {
            axios.post(`/api/update/cms/page/${pageId}`, data).then(res => {
                if (res.data.result) {
                    hideLoader();
                    swal("success", "Page Updated Successfully Done", "success");
                    console.log(res.data.result);

                    setError([])
                    history.push('/admin/page/index');
                }
                else {
                    hideLoader();
                    console.log(res.data);
                    setError(res.data.errors);
                }
            });
        });
    }


    return (
        <div className="container-fluid">
            <div className="card shadow mb-4">
                <div className="card-header py-3">
                    <h4 className="card-title mb-0">Edit Page</h4>
                </div>
                <div className="card-body">
                    <form onSubmit={updatePage}>
                    <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="name">Title</label>
                                    <input type="text" name="title" onChange={handleInput} value={pageInput.title} className="form-control" placeholder="Enter Page Title" />
                                    <span className="validate-error-message">{error.title}</span>

                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="name">Url</label>
                                    <input type="text" name="url" onChange={handleInput} value={pageInput.url} className="form-control" placeholder="Enter Page Url" />
                                    <span className="validate-error-message">{error.url}</span>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label htmlFor="userName">Description</label>
                                    <CKEditor
                                        editor={ClassicEditor}
                                        onChange={handleEditorOnChange}
                                        data={pageInput.description}
                                        value={pageInput.description}

                                    />
                                    {/* <textarea type="text" name="description" onChange={handleInput} value={pageInput.description} className="form-control" placeholder="Enter Page Content" /> */}
                                    
                                    <span className="validate-error-message">{error.description}</span>
                                </div>
                            </div>
                        </div>
                        <div className="row ">
                            <div className="col-md-12 text-right">
                                <button type="submit" className="btn btn-primary">Update</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            {loader}
        </div>
    );
}
export default EditPage;